/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

/**
 * region for redux*/
import { connect } from 'react-redux';
import { MiniSitesActions } from '../../actions/MiniSitesActions';

/**
 * region for styles*/
import { basicDetailsStyle } from './style/basicDetailsStyle';

/**
 * region for componets*/
import BasicDetailsName from './common/BasicDetailsName';
import BasicDetailsSubDomain from './common/BasicDetailsSubDomain';
import BasicDetailsDomain from './common/BasicDetailsDomain';
import BasicDetailsImageUpload from './common/BasicDetailsImageUpload';

class BasicDetails extends Component {

    state = {
        reload: false
    };

    componentDidMount() {
        const reload = this.props.reload;
        this.setState({ reload: reload });
        this.props.fetchMiniSiteGetListDomain();
    }

    fetchMiniSiteSetAttributes(attributes, error, id) {
        const dataBasicDetails = this.props.dataBasicDetails;
        if (id === "name") {
            dataBasicDetails.errors.name = error;
        }
        if (id === "subdomain") {
            dataBasicDetails.errors.subdomain = error;
        }
        if (id === "domain") {
            dataBasicDetails.errors.domain = error;
        }
        Object.assign(dataBasicDetails, attributes);
        this.props.fetchMiniSiteSetAttributes(dataBasicDetails);
    }

    render() {
        const { name, subdomain, domain, minisiteLogo, errors } = this.props.dataBasicDetails;
        const { selectListDomain } = this.props;
        return (
            <Fragment>
                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={0}>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <BasicDetailsName
                                name={name}
                                nameError={errors.name}
                                onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item sm={6}>
                            <BasicDetailsSubDomain
                                name={subdomain}
                                nameError={errors.subdomain}
                                onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                        </Grid>
                        <Grid item sm={6}>
                            <BasicDetailsDomain
                                name={domain}
                                nameError={errors.domain}
                                selectListDomain={selectListDomain}
                                onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <BasicDetailsImageUpload
                                minisiteLogo={minisiteLogo}
                                onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment >
        );
    }
}

BasicDetails.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const dataBasicDetails = state.MiniSitesReducers.dataBasicDetails;
    const selectListDomain = state.MiniSitesReducers.selectListDomain
    const reload = state.MiniSitesReducers.reload;
    const pending = state.MiniSitesReducers.pending;

    return {
        dataBasicDetails,
        selectListDomain,
        reload,
        pending
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchMiniSiteGetListDomain: () => dispatch(MiniSitesActions.fetchMiniSiteGetListDomain()),
        fetchMiniSiteSetAttributes: (attributes, error, id) => dispatch(MiniSitesActions.fetchMiniSiteSetAttributes(attributes, error, id)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(basicDetailsStyle)(BasicDetails));

